import { environment } from '../../enviroments/enviroment'

export const normalizePathname = (p: string) => {
  try {
    const base = (environment.publicUrl ?? '').replace(/\/$/, '')
    if (!p) return p
    if (base && p.startsWith(base)) {
      const stripped = p.slice(base.length)
      return stripped.startsWith('/') ? stripped : `/${stripped}`
    }
    return p
  } catch (e) {
    return p
  }
}
